import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { LabelModeEnum, LabelTypeEnum } from '../../p-status-main-label';
import { PFieldAbstractComponent } from '../p-field-abstract';

import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ListItem } from '../p-field-single-select';

@Component({
    selector: 'p-field-entity-status',
    template: `
        <p-status-main-label
            *ngIf="isDisabled && statusName"
            [mode]="mode"
            [type]="color"
            fxLayout
            fxLayoutAlign="center center"
            [label]="statusName"
            [attr.automation-id]="'p-field-entity-status_disabled_' + automationIdSuffix"
        ></p-status-main-label>

        <p-status-main-label
            *ngIf="!isDisabled"
            [mode]="mode"
            [type]="color"
            fxLayout
            fxLayoutAlign="center center"
            [label]="statusName"
            [isTriggerMenu]="true"
            [matMenuTriggerFor]="statusPicker"
            [attr.automation-id]="'p-field-entity-status_' + automationIdSuffix"
            class="status-picker"
        ></p-status-main-label>

        <mat-menu #statusPicker="matMenu" class="no-padding p-menu">
            <ng-template matMenuContent>
                <div>
                    <p-picker-single-select
                        [list]="list"
                        [canSearch]="false"
                        [value]="statusName"
                        (valueChange)="changeValue($event); statusPicker.close.emit()"
                    >
                    </p-picker-single-select>
                </div>
            </ng-template>
        </mat-menu>
    `,
    styleUrls: ['./p-field-entity-status.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldEntityStatusComponent
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PFieldEntityStatusComponent extends PFieldAbstractComponent<number | string> {
    @Input() statusTranslatePrefix?: string;
    @Input() list: ListItem[] = [];
    @Input() statusColors?: Record<string, LabelTypeEnum>;
    @Input() override isDisabled = false;
    @Input() automationIdSuffix?: string;
    @Input() mode?: LabelModeEnum;

    constructor(cd: ChangeDetectorRef, private translate: TranslateService) {
        super(cd);
    }

    // getStatusName() {
    //     return !!this.statusTranslatePrefix
    //         ? this.translate.instant(`${this.statusTranslatePrefix}.${this.formattedStatus}`)
    //         : this.statusName;
    // }

    get color() {
        if (this.formattedStatus) {
            if (!!this.statusColors && !!this.statusColors[this.formattedStatus]) {
                return this.statusColors[this.formattedStatus];
            }
            return '';
        }
        return '';
    }

    get statusName() {
        if (this.list?.length > 0) {
            return this.list.find((status) => status.id === this.value)?.name;
        } else {
            return this.value?.toString();
        }
    }

    get formattedStatus() {
        return this.statusName?.toUpperCase().split(' ').join('_');
    }

    changeValue(value: number) {
        this.markAsTouched();
        if (value || value > -1) {
            this.value = value;
            this._onChange(value);
            this.valueChange?.emit(value);
        }
    }
}
